import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import {
  step01Outline,
  step01Fill,
  step02Outline,
  step02Fill,
  step03Outline,
  step03Fill,
} from "../assets/appImages";

const STEP_LAYERS = {
  "01": { outline: step01Outline, fill: step01Fill },
  "02": { outline: step02Outline, fill: step02Fill },
  "03": { outline: step03Outline, fill: step03Fill },
};

const StepNumber = ({ value }) => {
  const layers = STEP_LAYERS[value];

  if (!layers) return null;

  return (
    <div className="relative h-[80px] w-[104px] shrink-0">
      <img
        src={layers.fill}
        alt=""
        aria-hidden="true"
        className="absolute top-[16px] h-[80px] w-[104px] object-contain object-left"
      />
      <img
        src={layers.outline}
        alt={`Step ${value}`}
        aria-hidden="true"
        className="relative z-[1] h-[80px] w-[104px] object-contain object-left"
      />
    </div>
  );
};

const ViewMoreButton = ({ featured = false, to }) => (
  <Link
    to={to}
    className={`mt-8 inline-flex w-fit items-stretch overflow-hidden rounded-lg transition-opacity hover:opacity-90 ${
      featured ? "bg-white" : "bg-[#E1E2F6]"
    }`}
  >
    <span
      className={`flex items-center px-5 py-2.5 text-[14px] font-semibold ${
        featured ? "text-brand-orange" : "text-brand-purple"
      }`}
    >
      View More
    </span>
    <span
      className={`m-1 flex w-9 shrink-0 items-center justify-center rounded-md ${
        featured ? "bg-brand-orange text-white" : "bg-white text-brand-purple"
      }`}
    >
      <FaChevronRight className="text-[12px]" aria-hidden="true" />
    </span>
  </Link>
);

const WorkingProcess = ({ steps }) => {
  const items = Array.isArray(steps) ? steps : [];

  if (items.length === 0) return null;

  return (
    <section className="bg-[#F5F5FC] py-12 md:py-16 lg:py-20">
      <svg className="absolute h-0 w-0" aria-hidden="true">
        <defs>
          <filter id="step-remove-black" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  1 1 1 0 -0.04"
            />
          </filter>
        </defs>
      </svg>

      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="text-[18px] font-bold text-[#F17732]">Working Process</p>
          <h2 className="mt-2 text-3xl font-bold text-brand-purple md:text-4xl lg:text-[2.5rem]">
            How we works?
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 items-center gap-6 md:mt-12 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
          {items.map((step) => {
            const featured = step.variant === "featured";

            return (
              <article
                key={step.id || step.number}
                className={`flex flex-col rounded-[18px] px-6 py-8 md:px-7 md:py-9 ${
                  featured
                    ? "bg-brand-orange text-white shadow-[0_18px_40px_rgba(241,119,50,0.35)] lg:min-h-[320px] lg:py-10"
                    : "bg-white text-[#444444] shadow-[0_8px_28px_rgba(0,0,0,0.06)]"
                }`}
              >
                <StepNumber value={step.number} />

                <h3
                  className={`mt-4 text-[18px] font-bold md:text-[20px] ${
                    featured ? "text-white" : "text-brand-orange"
                  }`}
                >
                  {step.title}
                </h3>

                <div
                  className={`working-process-description mt-4 flex-1 text-[14px] leading-[1.75] [&_p]:m-0 ${
                    featured ? "text-white/95 [&_*]:text-white/95" : "text-[#444444]"
                  }`}
                  dangerouslySetInnerHTML={{ __html: step.description || "" }}
                />

                <ViewMoreButton featured={featured} to={step.to} />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WorkingProcess;
